// import bootstrap from 'bootstrap'
// import { Modal, Dropdown } from "bootstrap"; 
import React, { useState } from 'react'

import logo from './images/YHYGlobal.png'
import logoRTL from './images/YHYGlobalRTL.png'
import logoLight from './images/YHYGlobal_light.png'
import logoRTLLight from './images/YHYGlobalRTL_light.png'

function App () {
    // window.Modal = Modal;
    // window.Dropdown = Dropdown;
    function darkMode0(){
        if(isDarkMode0){
            document.getElementById('daddy').setAttribute('data-bs-theme', 'light')
            setDarkMode0(false)
            // document.getElementById('darkMode0').innerHTML = '🌙 Dark Mode'
            // document.getElementById('darkMode0').classList.remove("btn-dark")
            // document.getElementById('darkMode0').classList.add("btn-light")
        } else {        
            document.getElementById('daddy').setAttribute('data-bs-theme', 'dark')
            setDarkMode0(true)
            // document.getElementById('darkMode0').innerHTML = '🌞 Light Mode'
            // document.getElementById('darkMode0').classList.remove("btn-light")
            // document.getElementById('darkMode0').classList.add("btn-dark")
        }
    }

    const today = new Date();
    const year = today.getFullYear();
    const [lang,setLang] = useState("en")
    const [isDarkMode0, setDarkMode0] = useState((window.matchMedia ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false) : true))
    
    const langs = {
        'fi':'🇫🇮 | Suomi',
        'ar':'🇦🇪 | العربية',
        'ru':'🇷🇺 | Русский',
        'es':'🇪🇸 | Español',
        'en':'🇺🇸 | English'
    }
    const textsArr = [
        {
            'fi':'innovatiivinen teknologia konsultointi',
            'ar':'استشارات تقنية مبتكرة',
            'ru':'консультации по инновационному технологиям',
            'es':'consultoría de tecnológica innovadora',
            'en':'innovative technology consultancy'
        },
        {
            'fi':'koti',
            'ar':'الرئيسية',
            'ru':'дом',
            'es':'la casa',
            'en':'home'
        },
        {
            'fi':'meiän tiimi',
            'ar':'فريقنا',
            'ru':'наша команда',
            'es':'nuestro equipo',
            'en':'our team'
        },
        {
            'fi':'erikoisuus',
            'ar':'المتخصصة',
            'ru':'специальности',
            'es':'especialidades',
            'en':'specialties'
        },
        {
            'fi':'ota yhteyttä',
            'ar':'الحصول على اتصال',
            'ru':'войдите в контакт',
            'es':'ponte en contacto',
            'en':'get in contact'
        },
        {
            'fi':'Todistetut Tulokset:',
            'ar':'نتائج مثبتة:',
            'ru':'Доказанные результаты:',
            'es':'Resultados Probados:',
            'en':'Proven Results:'
        },
        {
            'fi':'YHY Global LLC on menestyksekkäästi suunnitellut ja ottanut käyttöön yritystason ratkaisuja eri toimialoilla, mikä tuottaa mitattavaa ROI: ta ja operatiivista huippuosaamista asiakkaillemme.',
            'ar':'لقد نجحت شركة ياهي جلوبال ذ.م. م في تصميم ونشر حلول على مستوى المؤسسات عبر صناعات متنوعة ، مما يوفر عائد استثمار قابل للقياس وتميزا تشغيليا لعملائنا.',
            'ru':'Компания YHY Global LLC успешно разрабатывает и внедряет решения корпоративного уровня в различных отраслях промышленности, обеспечивая нашим клиентам ощутимую рентабельность инвестиций и операционное превосходство.',
            'es':'YHY Global LLC ha diseñado e implementado con éxito soluciones de nivel empresarial en diversas industrias, brindando un ROI medible y excelencia operativa para nuestros clientes.',
            'en':'YHY Global LLC has successfully engineered and deployed enterprise-grade solutions across diverse industries, delivering measurable ROI and operational excellence for our clients.'
        },
        {
            'fi':'jös sulla on GDPR/DMCA toivomus, tai erikoinen kysymys, lähetä meille viesti: contact@yhy.ae',
            'ar':'يهي غلوبال ذ م م هو العمل وراء تطوير المواقع التالية ورمز',
            'ru':'если у вас есть вапрос GDPR/DMCA или какой-либо другой вопрос, отправьте нам сообщение по адресу: contact@yhy.ae',
            'es':'si usted tenga una requesta de GDPR/DMCA, o algo otra preguntaba, mándanos mensaje a: contact@yhy.ae',
            'en':'if you have a GDPR/DMCA request, or some other question, send us a message at: contact@yhy.ae'
        },
        {
            'fi':'ohjaa kaikki tiedustelut osoitteeseen: contact@yhy.ae',
            'ar':'contact@yhy.ae توجيه جميع الاستفسارات إلى',
            'ru':'направляйте все запросы по адресу: contact@yhy.ae',
            'es':'envió todas sus preguntas a: contact@yhy.ae',
            'en':'direct all inquiries to: contact@yhy.ae'
        },
        {
            'fi':'Katerina',
            'ar':'كيت',
            'ru':'Екатерина',
            'es':'Ekaterina',
            'en':'Kate'
        },
        {
            'fi':'Hallinnon Osakas',
            'ar':'الشريك الإداري',
            'ru':'Управляющий партнер',
            'es':'Socio Gerente',
            'en':'Managing Partner'
        },
        {
            'fi':'Aleksaanteri',
            'ar':'أليكس',
            'ru':'Алекс',
            'es':'Alejandro',
            'en':'Alex'
        },
        {
            'fi':'Tekninen Pääarkkitehti, Strategi',
            'ar':'المهندس المعماري التقني الرئيسي والاستراتيجي',
            'ru':'Главный технический архитектор и стратег',
            'es':'Arquitecto Técnico Principal y Estratega',
            'en':'Principal Technical Architect & Strategist'
        },
        // {
        //     'fi':'Perustaja, Johtaja, Pääinsinööri',
        //     'ar':'مؤسس ، مدير ، مهندس رئيسي',
        //     'ru':'Основатель, директор, главный инженер',
        //     'es':'Fundador, Director, Ingeniero Principal',
        //     'en':'Founder, Director, Principal Engineer'
        // },
        {
            'fi':'Ydinpalveluominaisuudet:',
            'ar':'قدرات الخدمة الأساسية:',
            'ru':'Основные возможности сервиса:',
            'es':'Capacidades básicas del servicio:',
            'en':'Core Service Capabilities:'
        },
        {
            'fi':'End-to-End IT & Software Engineering Services',
            'ar':'خدمات هندسة تكنولوجيا المعلومات والبرمجيات الشاملة',
            'ru':'Комплексные услуги в области информационных технологий и разработки программного обеспечения',
            'es':'Servicios Integrales de Ingeniería de TI y Software',
            'en':'End-to-End IT & Software Engineering Services'
        },
        {
            'fi':'Enterprise tietojärjestelmäarkkitehtuuri ja-kehitys',
            'ar':'هندسة وتطوير برمجيات المؤسسات',
            'ru':'Архитектура и разработка корпоративного программного обеспечения',
            'es':'Arquitectura y desarrollo de Software empresarial',
            'en':'Enterprise Software Architecture & Development'
        },
        {
            'fi':'skaalautuva käyttöönotto ja jatkuva ylläpito',
            'ar':'النشر القابل للتطوير والصيانة المستمرة',
            'ru':'Масштабируемое развертывание и текущее обслуживание',
            'es':'Implementación Escalable y mantenimiento Continuo',
            'en':'Scalable Deployment & Ongoing Maintenance'
        },
        {
            'fi':'liiketoimintaprosessien suunnittelu ja optimointi',
            'ar':'هندسة العمليات التجارية والتحسين',
            'ru':'Разработка и оптимизация бизнес-процессов',
            'es':'Ingeniería y optimización de Procesos de negocio',
            'en':'Business Process Engineering & Optimization'
        },
        {
            'fi':'strategisen teknologian innovaatiot ja ongelmanratkaisu',
            'ar':'الابتكار التكنولوجي الاستراتيجي وحل المشكلات',
            'ru':'Стратегические технологические инновации и решение проблем',
            'es':'Innovación Tecnológica Estratégica y Resolución de Problemas',
            'en':'Strategic Technology Innovation & Problem Solving'
        },
        {
            'fi':'älykäs tehtävien automaatio ja työnkulun parantaminen',
            'ar':'أتمتة المهام الذكية وتحسين سير العمل',
            'ru':'Интеллектуальная автоматизация задач и улучшение рабочего процесса',
            'es':'Automatización Inteligente de Tareas y Mejora del Flujo de trabajo',
            'en':'Intelligent Task Automation & Workflow Enhancement'
        },
        {
            'fi':'monen ympäristön asiantuntemus: pilvi natiivi, hybridi ja on-Premises',
            'ar':'خبرة متعددة البيئات: السحابة الأصلية والهجينة والمحلية',
            'ru':'Опыт работы с несколькими средами: Нативное, гибридное и локальное облако',
            'es':'Experiencia en múltiples entornos: Nativo de la Nube, Híbrido y Local',
            'en':'Multi-Environment Expertise: Cloud Native, Hybrid & On-Premises'
        },
        {
            'fi':'erikoistunut Tuotekehitysosaaminen:',
            'ar':'الخبرة المتخصصة في تطوير المنتجات:',
            'ru':'Специализированный опыт разработки продуктов:',
            'es':'Experiencia especializada en Desarrollo de productos:',
            'en':'Specialized Product Development Expertise:'
        },
        {
            'fi':'suunnittelemme ja toimitamme huippuluokan ratkaisuja, mukaan lukien:',
            'ar':'نحن مهندس وتقديم الحلول المتطورة بما في ذلك:',
            'ru':'Мы разрабатываем и поставляем передовые решения, в том числе:',
            'es':'Diseñamos y entregamos soluciones de vanguardia que incluyen:',
            'en':'We architect and deliver cutting-edge solutions including:'
        },
        {
            'fi':'Advanced AI-Powered Spam Detection Systems',
            'ar':'أنظمة متقدمة للكشف عن الرسائل غير المرغوب فيها تعمل بالذكاء الاصطناعي',
            'ru':'Усовершенствованные системы обнаружения спама на базе искусственного интеллекта',
            'es':'Sistemas Avanzados de Detección de Spam Impulsados por IA',
            'en':'Advanced AI-Powered Spam Detection Systems'
        },
        {
            'fi':'seuraavan sukupolven tekoälyyn Integroidut sähköposti-ja CRM-alustat',
            'ar':'الجيل القادم من منصات البريد الإلكتروني وإدارة علاقات العملاء المتكاملة بالذكاء الاصطناعي',
            'ru':'Платформы электронной почты и CRM, интегрированные с ИИ, нового поколения',
            'es':'Plataformas de CRM y correo electrónico Integradas con IA de próxima Generación',
            'en':'Next-Generation AI-Integrated Email & CRM Platforms'
        },
        {
            'fi':'mukautetut TEKOÄLYMALLIT ja älykäs Agenttikehitys',
            'ar':'نماذج مخصصة لمنظمة العفو الدولية وتطوير وكيل ذكي',
            'ru':'Пользовательские модели ИИ и разработка интеллектуальных агентов',
            'es':'Modelos Personalizados de IA y Desarrollo de Agentes Inteligentes',
            'en':'Custom AI Models & Intelligent Agent Development'
        },
        {
            'fi':'Domain-Specific Large Language Models (LLM)',
            'ar':'نماذج اللغات الكبيرة الخاصة بالمجال',
            'ru':'Большие языковые модели для конкретной предметной области (LLM)',
            'es':'Modelos de Lenguaje Grande (LLM) Específicos del Dominio',
            'en':'Domain-Specific Large Language Models (LLMs)'
        },
        {
            'fi':'suojatut, Yksityiset OTM-Sovellukset arkaluonteisille tiedoille',
            'ar':'تطبيقات ماجستير آمنة وخاصة للبيانات الحساسة',
            'ru':'Защищенные частные приложения LLM для конфиденциальных данных',
            'es':'Aplicaciones LLM Privadas y Seguras para Datos Confidenciales',
            'en':'Secure, Private LLM Applications for Sensitive Data'
        },
        {
            'fi':'Custom Blockchain & Distributed Ledger Solutions',
            'ar':'بلوكتشين مخصص وحلول دفتر الأستاذ الموزع',
            'ru':'Пользовательские решения для блокчейна и распределенных реестров',
            'es':'Soluciones Personalizadas de Blockchain y Contabilidad Distribuida',
            'en':'Custom Blockchain & Distributed Ledger Solutions'
        },
        {
            'fi':'korkean suorituskyvyn tietojenkäsittely-ja analytiikka-alustat',
            'ar':'منصات معالجة البيانات والتحليلات عالية الأداء',
            'ru':'Высокопроизводительные платформы для обработки данных и аналитики',
            'es':'Plataformas Analíticas y de Procesamiento de Datos de alto Rendimiento',
            'en':'High-Performance Data Processing & Analytics Platforms'
        },
        {
            'fi':'Maks',
            'ar':'ماكس',
            'ru':'Макс',
            'es':'Maximilian',
            'en':'Max'
        },
        {
            'fi':'Testaus Ja Laadunvarmistus',
            'ar':'اختبار وضمان الجودة',
            'ru':'Тестирование и контроль качества',
            'es':'Pruebas y Garantía de Calidad',
            'en':'Testing & Quality Assurance'
        },
    ]

    const checkDir = (selectedLang) => {
        if(selectedLang === 'ar'){
            document.getElementById('parentDirectionDiv').dir = 'rtl'
        } else {
            document.getElementById('parentDirectionDiv').dir = 'ltr'
        }
    }

    return (
        <div className="container" dir='ltr' id='parentDirectionDiv'>
            <div className="container text-left">
                <div className="row align-items-center">
                    <div className="col-6">
                        { (isDarkMode0 == true ? (lang == 'ar' ? (<img src={logoRTL} className="d-block w-100 p3" alt="YHY Global LLC Logo" />) : (<img src={logo} className="d-block w-100 p3" alt="YHY Global LLC Logo" />)) : (lang == 'ar' ? (<img src={logoRTLLight} className="d-block w-100 p3" alt="YHY Global LLC Logo" />) : (<img src={logoLight} className="d-block w-100 p3" alt="YHY Global LLC Logo" />))) }
                        {/* <img src={logo} className="d-block w-100 p3" alt="YHY Global LLC Logo" /> */}
                    </div>
                    <div className="col-6 p-3">
                        YHY Global LLC<br/>
                        {textsArr[0][lang]}<br/><br/>
                        <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {langs[lang]}
                            </button>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item" onClick={()=>{setLang('en'); checkDir('en')}} href="#">🇺🇸 | English</a></li>
                                <li><a className="dropdown-item" onClick={()=>{setLang('ar'); checkDir('ar')}} href="#">🇦🇪 | العربية</a></li>
                                {/* <li><a className="dropdown-item" onClick={()=>{setLang('ru'); checkDir('ru')}} href="#">🇷🇺 | Русский</a></li> */}
                                <li><a className="dropdown-item" onClick={()=>{setLang('fi'); checkDir('fi')}} href="#">🇫🇮 | Suomi</a></li>
                                <li><a className="dropdown-item" onClick={()=>{setLang('es'); checkDir('es')}} href="#">🇪🇸 | Español</a></li>
                            </ul>
                        </div>
                        <br/>
                        <button type="button" id="darkMode0" onClick={()=>darkMode0()} className={isDarkMode0?'btn btn-dark':'btn btn-light'}>{isDarkMode0?`🌞 Light Mode`:`🌙 Dark Mode`}</button>
                    </div>
                </div>
                <br/><br/>
            </div>
            {/* accordion color set #151879 */}
            <div className="accordion" id="myAccordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" style={{'--bs-primary-text-emphasis':'#FFFFFF'}}>
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        {textsArr[1][lang]}
                    </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#myAccordion">
                    <div className="accordion-body">
                        <div className='container text-center'>
                            <p><strong>{textsArr[5][lang]}</strong> {textsArr[6][lang]}</p>
                        </div>
                        <br/>
                        <div className='container text-center'>
                            {textsArr[8][lang]}
                        </div>
                    </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" style={{'--bs-primary-text-emphasis':'#FFFFFF'}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        {textsArr[2][lang]}
                    </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#myAccordion">
                    <div className="accordion-body">
                        <div className="row align-items-start">
                            <div className="col-6 p-3">
                                <strong>{textsArr[9][lang]}</strong><br/>
                                <p>{textsArr[10][lang]}</p>
                                <a href="mailto:kate@yhy.fi" alt="mail">kate@yhy.fi</a><span> / </span>
                                <a href="mailto:kate@yhy.ae" alt="mail">kate@yhy.ae</a>
                            </div>
                        </div>
                        <div className="row align-items-start">
                            <div className="col-6 p-3">
                                <strong>{textsArr[11][lang]}</strong><br/>
                                <p>{textsArr[12][lang]}</p>
                                <a href="mailto:alex@yhy.fi" alt="mail">alex@yhy.fi</a><span> / </span>
                                <a href="mailto:alex@yhy.ae" alt="mail">alex@yhy.ae</a>
                            </div>
                        </div>
                        <div className="row align-items-start">
                            <div className="col-6 p-3">
                                <strong>{textsArr[30][lang]}</strong><br/>
                                <p>{textsArr[31][lang]}</p>
                                <a href="mailto:max@yhy.fi" alt="mail">max@yhy.fi</a><span> / </span>
                                <a href="mailto:max@yhy.ae" alt="mail">max@yhy.ae</a>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" style={{'--bs-primary-text-emphasis':'#FFFFFF'}}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        {textsArr[3][lang]}
                    </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#myAccordion">
                    <div className="accordion-body">
                        <h3>{textsArr[13][lang]}</h3>
                        <ul>
                            <li>{textsArr[14][lang]}</li>
                            <li>{textsArr[15][lang]}</li>
                            <li>{textsArr[16][lang]}</li>
                            <li>{textsArr[17][lang]}</li>
                            <li>{textsArr[18][lang]}</li>
                            <li>{textsArr[19][lang]}</li>
                            <li>{textsArr[20][lang]}</li>
                        </ul>
                        <h3>{textsArr[21][lang]}</h3>
                        <p>{textsArr[22][lang]}</p>
                        <ul>
                            <li>{textsArr[23][lang]}</li>
                            <li>{textsArr[24][lang]}</li>
                            <li>{textsArr[25][lang]}</li>
                            <li>{textsArr[26][lang]}</li>
                            <li>{textsArr[27][lang]}</li>
                            <li>{textsArr[28][lang]}</li>
                            <li>{textsArr[29][lang]}</li>
                        </ul>                                        
                    </div>
                    </div>
                </div>
            </div>
            <br/><br/>
            <div className="container text-center">
                <p>©{year} YHY Global LLC</p>
                <p>Sharjah Media City</p>
                <p>Sharjah, United Arab Emirates</p>
            </div>
        </div>
      );
}

export default App